<div class="dropdown auto">
    <mat-form-field class="dropdown__content">
        <p matPrefix class="dropdown__content-prefix m-0 small flex align-center">
            <app-icon [name]="iconName" size="xs" class="mr-1"></app-icon>
            <span class="text-nowrap">{{ dropdownText }}:</span>
        </p>
        <mat-select (selectionChange)="onSelectedValueChange($event)" [value]="selectedValue" class="small">
            <ng-container>
                <mat-option *ngFor="let item of dropdownValue" [value]="item.value" class="option-container">
                    <ng-container class="dropdown__content__value p-0 small">
                        {{ (labelTranslationKey.length ? labelTranslationKey + '.' : '') + item.displayName | translate }}
                    </ng-container>
                </mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>
</div>